import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { AndonEditComponent } from './cam-andon-edit.component';

const SEBEP_RENK: Record<string, string> = { 'Makine Arızası': '#ff4d4f', 'Malzeme Bekleme': '#fa8c16', 'Kalite Problemi': '#faad14', 'Personel Yetersiz': '#722ed1', 'Enerji Kesintisi': '#13c2c2', 'Diğer': '#8c8c8c' };
const SEBEP_RGB: Record<string, string> = { 'Makine Arızası': '255,77,79', 'Malzeme Bekleme': '250,140,22', 'Kalite Problemi': '250,173,20', 'Personel Yetersiz': '114,46,209', 'Enerji Kesintisi': '19,194,194', 'Diğer': '140,140,140' };

@Component({
  selector: 'cam-andon-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--cam-andon" [style.--accent]="renk()" [style.--accent-rgb]="rgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">🚨 DURUŞ / YARDIM</div>
        <div class="an-baslik">{{ d('durusSebebi') || 'Sebep Belirtilmedi' }}</div>
        @if (d('durusSuresi')) { <div class="an-sure">⏱ {{ d('durusSuresi') }} dk</div> }
        @if (d('bildiren')) { <div class="an-alt">👤 {{ d('bildiren') }}</div> }
        @if (d('cozum')) { <div class="an-cozum">{{ d('cozum') }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? (d('cozum') ? 100 : 30) : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .an-baslik { font-size: 14px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .an-sure { font-size: 12px; font-weight: 600; color: var(--accent); }
    .an-alt { font-size: 11px; color: var(--py-metin-ikincil, #94a3b8); }
    .an-cozum { font-size: 10px; color: var(--py-metin-ucuncul, #64748b); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 2px; }
  `],
})
export class AndonKartComponent extends GameCardBase {
  parametreler = input<any>();
  _hesap = input<any>();
  constructor() { super(); }
  d(ismi: string) { return paramDeger(this.parametreler()?.ek, ismi); }
  renk = computed(() => SEBEP_RENK[this.d('durusSebebi')] || '#ff4d4f');
  rgb = computed(() => SEBEP_RGB[this.d('durusSebebi')] || '255,77,79');
}

@Component({
  selector: 'cam-andon-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#ff4d4f">
      <div class="sk-icerik">
        <div class="sk-baslik">🚨 {{ d('durusSebebi') || 'Sebep Belirtilmedi' }}</div>
        @if (d('bildiren')) { <div class="sk-alt">👤 {{ d('bildiren') }}</div> }
      </div>
      <div class="sk-sag">
        @if (d('durusSuresi')) { <span style="font-size:12px;font-weight:600;color:var(--py-metin,#333)">{{ d('durusSuresi') }} dk</span> }
        <span class="sk-chip" [style.border-color]="sebepRenk()" [style.color]="sebepRenk()">{{ d('durusSebebi') || 'Belirsiz' }}</span>
      </div>
    </div>
  `,
})
export class AndonKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
  sebepRenk = computed(() => SEBEP_RENK[this.d('durusSebebi')] || '#ff4d4f');
}

@DinamikBilesen({
  id: 'cam-andon',
  baslik: 'Duruş / Yardım',
  aciklama: 'Duruş ve yardım çağrısı takibi',
  ikon: 'alert',
  kategori: 'cam-isleme',
})
class CamAndon {
  paylas_kutusu = AndonEditComponent;
  paylasilmis_kart = AndonKartComponent;
  paylasilmis_kart_sade = AndonKartSadeComponent;
}
